module.exports = __webpack_public_path__ + "img/PC5.e71ddd81.png";